import EventNames from '@/lib/Events/EventNames';
import { container } from '@/container';
import { PrintCloverReceiptMixin } from '@/epos/vue/mixins/OrderReceiptMethods/PrintCloverReceiptMixin';
import { PrintOrderGiftAidDeclarationMixin } from '@/epos/vue/mixins/OrderReceiptMethods/PrintOrderGiftAidDeclarationMixin';
import { PrintOrderReceiptMixin } from '@/epos/vue/mixins/OrderReceiptMethods/PrintOrderReceiptMixin';
import { PrintOrderTicketsMixin } from '@/epos/vue/mixins/OrderReceiptMethods/PrintOrderTicketsMixin';
import { PrintPayyoReceiptMixin } from '@/epos/vue/mixins/OrderReceiptMethods/PrintPayyoReceiptMixin';
import { SendOrderEmailReceiptMixin } from '@/epos/vue/mixins/OrderReceiptMethods/SendOrderEmailReceiptMixin';

export const OrderPrintingMixin = {
    mixins: [
        PrintCloverReceiptMixin,
        PrintOrderGiftAidDeclarationMixin,
        PrintOrderReceiptMixin,
        PrintOrderTicketsMixin,
        PrintPayyoReceiptMixin,
        SendOrderEmailReceiptMixin,
    ],

    data() {
        return {
            isPrinting: false,
        };
    },

    created() {
        // This is workaround because Vue isn't listening to changes on "this.order.receiptPrinted".
        // Listen for "printing finished" events and update the "receiptPrinted" property from
        // the order at that point.
        this.deregisterPrintingFinishedListenerFunc = container.$rootScope.$on(
            EventNames.PRINTING_FINISHED,
            () => {
                setTimeout(() => {
                    this.receiptPrinted = this.receiptPrinted || this.order.receiptPrinted;
                }, 1);
            }
        );
    },

    beforeUnmount() {
        if (this.deregisterPrintingFinishedListenerFunc) {
            this.deregisterPrintingFinishedListenerFunc();
        }
    },
};
